import React, { PureComponent } from 'react';
import CSSModules from 'react-css-modules';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import copy from 'copy-to-clipboard';
import { Button, Icon, Input } from 'platfi-ui-components';

import { bemModifier } from 'utils/BEMHelper';

import styles from './CopyLinkTab.scss';

@CSSModules(styles, { allowMultiple: true })
class CopyLinkTab extends PureComponent {
  static propTypes = {
    inviteLink: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  };

  state = { copied: false };

  onCopy = () => {
    const { copied } = this.state;
    const { inviteLink } = this.props;

    if (copied) {
      return;
    }

    copy(inviteLink);

    this.setState({ copied: true });

    this.animationTimeout = setTimeout(() => {
      this.setState({ copied: false });
    }, 1500);
  };

  componentWillUnmount() {
    clearTimeout(this.animationTimeout);
  }

  render() {
    const { inviteLink } = this.props;
    const { copied } = this.state;
    const stylesName = classNames(...bemModifier('m-copy-link__tooltip', { visible: copied }));

    return (
      <React.Fragment>
        <Input placeholder={inviteLink} type="text" value={inviteLink} />

        <div className="u-align-right o-modal-form__actions" styleName="m-copy-link">
          <Button label="Copy URL" onClick={this.onCopy} large primary />

          <div styleName={stylesName}>
            <Icon icon="round_outlined_check" styleName="m-copy-link__tooltip-icon" />
            Link copied to clipboard!
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default CopyLinkTab;
